<template>
  <div>
    <mustache-template label="Conversation ID" class="mb-3" :value="settings.conversationId"
      @input="(val) => onUpdate(val, 'settings.conversationId')" :suggestions="availableInputFields"
      :singleLine="true" />
    <mustache-template label="Message ID (optional)" class="mb-3" :value="settings.messageId"
      @input="(val) => onUpdate(val, 'settings.messageId')" :suggestions="availableInputFields" :singleLine="true" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MustacheTemplate from '@/components/mustache/mustache-template.vue';

const { mapGetters: workflowDetailsGetters } =
  createNamespacedHelpers('workflows/details');

export default {
  name: 'podium_read_message',
  components: {
    MustacheTemplate,
  },
  props: {
    availableInputFields: { required: true },
  },
  computed: {
    ...workflowDetailsGetters({
      selectedNode: 'SELECTED_NODE',
    }),
    settings() {
      return this.selectedNode.settings;
    },
  },
  methods: {
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
  }
};
</script>

<style scoped lang="scss"></style>
